import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import Environment from '@eatzy/common-reactjs/Environment';
import { filterTabletPairingBreadcrumb } from './tabletPairingPrivacy';
import { dropExtensionPostMessageNoise } from './bugsnag/extensionNoiseFilter';
import {
  dropResizeObserverNoise,
  installResizeObserverConsoleFilter,
} from './bugsnag/resizeObserverNoiseFilter';

// Make sure runtime env vars (window._env_json injected by the SSR template)
// are parsed before we read EATZY_ENVIRONMENT — otherwise getEnv falls back to
// the build-time process.env value and the wrong releaseStage gets baked in.
// parseInitialEnv is idempotent, so the later App.js call is harmless.
Environment.parseInitialEnv();

Bugsnag.start({
  apiKey: Environment.getEnv('BUGSNAG_API_KEY'),
  plugins: [new BugsnagPluginReact()],
  // Tag every event with the actual deploy environment (development / staging /
  // production) so the Bugsnag inbox can be triaged per-env instead of every
  // event landing in the default 'production' bucket. We deliberately do NOT
  // set enabledReleaseStages here: events from every environment flow through,
  // each labelled with their real releaseStage so they can be filtered in the
  // Bugsnag UI.
  releaseStage: Environment.getEnv('EATZY_ENVIRONMENT'),
  onBreadcrumb: filterTabletPairingBreadcrumb,
  // Suppress the "RangeError: Failed to execute 'postMessage' on 'Window'"
  // events that bubble up from browser-extension-injected scripts
  // (Grammarly, React/Redux DevTools, password managers, etc.). See
  // utils/bugsnag/extensionNoiseFilter.js — the filter is intentionally
  // narrow: it only drops events whose stack trace has zero frames inside
  // our bundle, so a real regression in our own code would still come
  // through.
  onError: (event) => {
    if (dropExtensionPostMessageNoise(event) === false) return false;
    if (dropResizeObserverNoise(event) === false) return false;
    return undefined;
  },
});

installResizeObserverConsoleFilter();

export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export default Bugsnag;
